var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefingIconTransport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.166 10.26a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0Zm-6.666 0a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0Zm0-2.593h8V4.333h-8v3.334Zm6.59-5a9.562 9.562 0 0 1-.094-.217.438.438 0 0 0-.32-.259C10.212 2.077 9.494 2 8.5 2c-.994 0-1.712.077-2.177.191a.438.438 0 0 0-.32.259c-.028.068-.06.142-.093.217H4.166a1 1 0 0 0-1 1v10c0 .184.15.333.334.333h.667c.184 0 .333-.15.333-.333v-.907h8v.907c0 .184.15.333.333.333h.667c.184 0 .333-.15.333-.333v-10a1 1 0 0 0-1-1H11.09Z"
  })));
}
export default SvgBriefingIconTransport;